import React, { ReactNode } from 'react';
import { Props as ToggleButtonProps } from './ToggleButton';
import clsx from 'clsx';
import './ToggleButtonGroup.less';

interface Props<T> {
  value?: T;
  className?: string;
  children: ReactNode;
  onChange: (value: T) => void;
}

export default function ToggleButtonGroup<T extends string | number>({
  value,
  onChange,
  className,
  children,
}: Props<T>) {
  function handleClick(newValue: T) {
    if (newValue !== value) {
      onChange(newValue);
    }
  }

  return (
    <div className={clsx('toggle-button-group', className)}>
      {React.Children.map(children, child => {
        if (!React.isValidElement<ToggleButtonProps<T>>(child)) return null;

        return React.cloneElement(
          child as React.ReactElement<ToggleButtonProps<T>>,
          {
            onClick: () => handleClick(child.props.value),
            selected: value === child.props.value,
          },
        );
      })}
    </div>
  );
}
